import { throwError as observableThrowError, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { FilterUpdateModel } from 'src/Models/TRFAUpdateModel';

@Injectable({
  providedIn: 'root'
})
export class TrfaUpdateMasterService {
  AppUrl = '';
  filterUpdateModel = new FilterUpdateModel();
  constructor(private readonly _http: HttpClient) {
    this.setAPIUrl();
  }

  setAPIUrl() {
    if (sessionStorage.getItem('BaseURL') != null && sessionStorage.getItem('BaseURL') != '') {
      this.AppUrl = sessionStorage.getItem('BaseURL') || '';
    }
  }

  private handleError(error: HttpErrorResponse) {
    console.error(error.message || error);
    return observableThrowError(() => error.status);
  }

  GetAllUpdate(TokenKey: string, PageNumber: number, PageSize: number, fundID: string, stateID: string, orderBy: string): Observable<any> {
    this.filterUpdateModel = {
      pageNumber: PageNumber,
      pageSize: PageSize,
      fundID,
      stateID,
      orderBy,
      fromDate: '',
      toDate: ''
    };
    this.setAPIUrl();
    const URL = this.AppUrl + 'api/TRFAUpdateMaster/GetAllUpdate';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(URL, this.filterUpdateModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  UpdateAddUpdate(TokenKey: string, addNewActionModel: any): Observable<any> {
    this.setAPIUrl();
    const URL = this.AppUrl + 'api/TRFAUpdateMaster/UpdateAddUpdate';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(URL, addNewActionModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetUpdateById(TokenKey: string, updateId: number): Observable<any> {
    this.setAPIUrl();
    const data = 'api/TRFAUpdateMaster/GetUpdateById/' + updateId;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  DeleteUpdate(TokenKey: string, updateId: number): Observable<any> {
    this.setAPIUrl();
    const data = 'api/TRFAUpdateMaster/DeleteUpdate/' + updateId;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetAllUpdateByUser(TokenKey: string, PageNumber: number, PageSize: number, fundID: string, stateID: string, fromDate: string, toDate: string, orderBy: string, isAdmin: boolean, userId: number, isFavorite: number): Observable<any> {
    this.filterUpdateModel = {
      pageNumber: PageNumber,
      pageSize: PageSize,
      fundID,
      stateID,
      orderBy,
      fromDate,
      toDate,
      isAdmin,
      userId,
      isFavorite,
    };
    this.setAPIUrl();
    const URL = this.AppUrl + 'api/TRFAUpdateMaster/GetAllUpdateByUser';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(URL, this.filterUpdateModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  ExportUpdates(TokenKey: string, PageNumber: number, PageSize: number, fundID: string, stateID: string, fromDate: string, toDate: string, orderBy: string): Observable<any> {
    this.filterUpdateModel = {
      pageNumber: PageNumber,
      pageSize: PageSize,
      fundID,
      stateID,
      orderBy,
      fromDate,
      toDate
    };
    this.setAPIUrl();
    const URL = this.AppUrl + 'api/TRFAUpdateMaster/ExportUpdates';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(URL, this.filterUpdateModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetTRFANotificationHistory(TokenKey: string, paramvalue: string): Observable<any> {
    this.setAPIUrl();
    const data = 'api/TRFAUpdateMaster/GetTRFANotificationHistory/' + paramvalue;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetAllUpdateV2(TokenKey: string, PageNumber: number, PageSize: number, fundID: string, stateID: string, orderBy: string,_IsExport:boolean): Observable<any> {
    this.filterUpdateModel = {
      pageNumber: PageNumber,
      pageSize: PageSize,
      fundID,
      stateID,
      orderBy,
      fromDate: '',
      toDate: '',
      IsExport:_IsExport
    };
    this.setAPIUrl();
    const URL = this.AppUrl + 'api/TRFAUpdateMaster/V2/GetAllUpdate';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(URL, this.filterUpdateModel, httpOptions)
      .pipe(catchError(this.handleError));
  }
}
